import type { CtaType } from "@vital/shared";
import { cmsStrings } from "../terminology";

type Props = {
  advertiserName: string;
  sponsorshipLabel: string;
  headline: string;
  description: string;
  offerText: string;
  ctaLabel: string;
  ctaType: CtaType;
  imageUrl?: string | null;
  imageAlt?: string;
};

export function SponsoredPreview({
  advertiserName,
  sponsorshipLabel,
  headline,
  description,
  offerText,
  ctaLabel,
  ctaType: _ctaType,
  imageUrl,
  imageAlt = "",
}: Props) {
  const c = cmsStrings.sponsoredComposer;
  const hasCta = ctaLabel.trim().length > 0;
  const label = sponsorshipLabel.trim() || "آگهی";
  const guestAdvertiser = advertiserName.trim() || c.previewEmptyAdvertiser;

  return (
    <div className="login-preview" aria-label={c.previewAria}>
      <p className="login-preview__viewport">
        <bdi dir="ltr" className="ltr-isolate latin-digits">
          320px
        </bdi>
      </p>
      <div className="login-preview__device">
        <header className="login-preview__brand">
          <p className="login-preview__brand-en ltr-isolate" dir="ltr">
            {cmsStrings.brand.nameEn}
          </p>
          <p className="login-preview__tagline">{c.previewTagline}</p>
        </header>
        <div className="login-preview__card">
          <p className="login-preview__welcome">{c.previewWelcome}</p>
          <div className="login-preview__fields" aria-hidden="true">
            <span className="login-preview__field-label">{c.previewUsername}</span>
            <span className="login-preview__field" />
            <span className="login-preview__field-label">{c.previewPassword}</span>
            <span className="login-preview__field" />
            <span className="login-preview__submit">{c.previewLoginSubmit}</span>
          </div>
        </div>
        <article className="login-preview__sponsored sponsored-preview-card" aria-label={cmsStrings.sponsoredUi.previewSlotAria}>
          <div className="sponsored-preview-card__header">
            <span className="sponsored-preview-card__label">{label}</span>
            <span className="sponsored-preview-card__advertiser">{guestAdvertiser}</span>
          </div>
          {imageUrl ? (
            <img
              className="sponsored-preview-card__image"
              src={imageUrl}
              alt={imageAlt || headline}
            />
          ) : (
            <div className="sponsored-preview-card__image-placeholder" aria-hidden="true">
              ★
            </div>
          )}
          <h3 className="sponsored-preview-card__headline">
            {headline.trim() || c.previewEmptyHeadline}
          </h3>
          <p className="sponsored-preview-card__description">
            {description.trim() || c.previewEmptyDescription}
          </p>
          {offerText.trim() ? (
            <p className="sponsored-preview-card__offer">{offerText.trim()}</p>
          ) : null}
          {hasCta ? (
            <button type="button" className="sponsored-preview-card__cta" disabled>
              {ctaLabel}
            </button>
          ) : null}
        </article>
      </div>
    </div>
  );
}
